export const trad = {
  "en-US": {
    PreHeader: {
      query: "Your query",
      lang: "Language",
      fetcher: "Fetcher",
      personalize: "Personalize your query!"
    },
    Body: {
      currentPage: "Current Page:",
      allResult: "Total Results:",
      retrieves: "Elements retrieves per page:",
      pageRight: "Go to the next page",
      pageLeft: "Go to the previous page"
    },
    Card: {
      airDate: "First air date:",
      pop: "Popularity:",
      originCountry: "Original Country:",
      button: "See more details..."
    },
    Details: {
      createBy: "Created by:",
      avgTimeEpi: "Average run time of the episodes:",
      firstAirDate: "First air date:",
      lastAirDate: "Last air date:",
      nbSeasons: "Number of seasons:",
      nbEpi: "Number of episodes:",
      webTitle: "Official web site"
    },
    Fetcher: {
      header: "Fetcher Query",
      lang: "Select the language",
      fetcher: "What do you want to fetch?",
      buttonFetch: "Fetch new content"
    }
  },
  "fr-FR": {
    PreHeader: {
      query: "Votre demande:",
      lang: "Langue:",
      fetcher: "Récupérateur:",
      personalize: "Personnalisez votre demande"
    },
    Body: {
      currentPage: "Actuel Page:",
      allResult: "Résultat total:",
      retrieves: "Eléments disponibles par page:",
      pageRight: "Aller à la prochaine page:",
      pageLeft: "Aller à la page précédante:"
    },
    Card: {
      airDate: "Première date de diffusion:",
      pop: "Popularité:",
      originCountry: "Pays original:",
      button: "Voir plus de détails"
    },
    Details: {
      createBy: "Crée par:",
      avgTimeEpi: "Temps moyen des épisodes:",
      firstAirDate: "Première date de diffusion:",
      lastAirDate: "Dernière date de diffusion:",
      nbSeasons: "Nombre de saisons:",
      nbEpi: "Nombre d'épisodes:",
      webTitle: "Site web officiel"
    },
    Fetcher: {
      header: "Récupérateur de demande",
      lang: "Langue",
      fetcher: "Votre recherche",
      buttonFetch: "Récupérer du nouveau contenu"
    }
  },
  "es-ES": {
    PreHeader: {
      query: "Su solicitud",
      lang: "Lengua",
      fetcher: "Recuperador",
      personalize: "Personalice su solicitud!"
    },
    Body: {
      currentPage: "Página actual:",
      allResult: "Resultado total:",
      retrieves: "Elemento recuperado por página:",
      pageRight: "Ir a la siguiente página:",
      pageLeft: "Ir a la página anterior:"
    },
    Card: {
      airDate: "Primera fecha de lanzamiento:",
      pop: "Popularidad:",
      originCountry: "País original:",
      button: "Ver más detalles"
    },
    Details: {
      createBy: "Creado por:",
      avgTimeEpi: "Tiempo promedio de episodios:",
      firstAirDate: "Primera fecha de lanzamiento:",
      lastAirDate: "Última fecha de lanzamiento:",
      nbSeasons: "Número de estaciones:",
      nbEpi: "Cantidad de episodios:",
      webTitle: "Sitio web oficial"
    },
    Fetcher: {
      header: "Solicitud de reclamo",
      lang: "Elija su solicitud",
      fetcher: "¿Qué quieres recuperar?",
      buttonFetch: "Recuperar nuevo contenido"
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/traductionsData.js